import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.regexp.constructor';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.regexp.to-string';
import { assertType, assertRange } from 'yaassertion';
import Cldr from 'cldrjs/dist/cldr';

function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function (t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}

/**
 * Error class to be used when WorldReady metadata is missing
 */
var MissingMetadataError = /*#__PURE__*/function (_Error) {
  function MissingMetadataError(message) {
    var _this;
    _this = _Error.call(this, message || "Missing WorldReady Metadata") || this;
    _this.code = "MISSING_METADATA";
    return _this;
  }
  _inheritsLoose(MissingMetadataError, _Error);
  return MissingMetadataError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Error class to be used when invalid params where passed to a function/method
 */
var InvalidParamsError = /*#__PURE__*/function (_Error2) {
  function InvalidParamsError(message) {
    var _this2;
    _this2 = _Error2.call(this, message || "Invalid params were provided") || this;
    _this2.code = "INVALID_PARAMS";
    return _this2;
  }
  _inheritsLoose(InvalidParamsError, _Error2);
  return InvalidParamsError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
/**
 * A map of supported document types to their respective sub-types.
 *
 * @constant {Object.<string, string[]>} SUPPORTED_DOCUMENT_TYPE_SUB_TYPE_MAP
 */
var SUPPORTED_DOCUMENT_TYPE_SUB_TYPE_MAP = {
  TAX_ID: ["VAT_ID", "SSN", "TIN", "ITIN", "STEUERNUMMER"]
};

/**
 * @class DocumentIdentifier
 * @description Represents a document identifier with region, type, and optional value.
 */
var DocumentIdentifier = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {string} region - The region of the document (e.g., 'US', 'CA').
   * @param {string} type - The type of the document (e.g., 'PASSPORT', 'DRIVING_LICENSE').
   * @param {object} options - The optional values for document (eg, subType).
   */
  function DocumentIdentifier(region, type, options) {
    var _documentIdentifierRe, _documentIdentifierRe2;
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      _options$subType = _options.subType,
      subType = _options$subType === void 0 ? "NONE" : _options$subType;
    try {
      assertType(region, "region", ["string"]);
      assertType(type, "type", ["string"]);
      assertType(options, "options", ["undefined", "plain object"]);
      assertRange(type, Object.keys(SUPPORTED_DOCUMENT_TYPE_SUB_TYPE_MAP), "Invalid value for type");
      assertRange(subType, SUPPORTED_DOCUMENT_TYPE_SUB_TYPE_MAP[type], "Invalid value for options.subType");
    } catch (error) {
      throw new InvalidParamsError(error.message);
    }
    var resolvedRegion = getResolvedRegion(region);
    var cldr = new Cldr("und");
    var documentIdentifierRegionMetadata = cldr.get(["supplemental", "documentIdentifier", resolvedRegion]);
    if (!documentIdentifierRegionMetadata) {
      throw new MissingMetadataError("Missing document identifer metadata for region: " + region);
    }
    var validationRegex = (_documentIdentifierRe = documentIdentifierRegionMetadata[type]) == null ? void 0 : (_documentIdentifierRe2 = _documentIdentifierRe[subType]) == null ? void 0 : _documentIdentifierRe2.validationRegex;
    if (!validationRegex) {
      throw new InvalidParamsError("Document identifier is not enabled for region: " + region + ", type: " + type + ", subType: " + subType);
    }
    this.regexEx = new RegExp(validationRegex.pattern, validationRegex.flag);
  }
  var _proto = DocumentIdentifier.prototype;
  _proto.validate = function validate(value) {
    try {
      assertType(value, "value", ["string"]);
    } catch (error) {
      throw new InvalidParamsError(error.message);
    }
    var result = [];
    if (!this.regexEx.test(value)) {
      result.push({
        code: "INVALID_PATTERN"
      });
    }
    return result;
  };
  return DocumentIdentifier;
}();

export { DocumentIdentifier };
